// With Vue custom element 

// Command : sudo vue build --target lib  --name reobs-tabular src/main-components.js --dest dist/tabular

// <script src="https://cdn.jsdelivr.net/npm/vue@2.6.11"></script>
// <link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css" rel="stylesheet">
// <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">   

// <script type="text/javascript" src="dist/quicklooks/reobs-quicklooks.umd.min.js"></script>
// <link rel="stylesheet" href="dist/quicklooks/reobs-quicklooks.css"></link>

import Vue from 'vue';
import vuetify from '../plugins/vuetify'
import vueCustomElement from 'vue-custom-element'
import Quicklooks from "../components/Quicklooks";

Vue.use(vueCustomElement)
Vue.customElement('reobs-quicklooks', {
    vuetify: vuetify,
    components : {Quicklooks},
    template:"<v-app><quicklooks></quicklooks></v-app>"})